import type {AppThunk} from '../../../../../actions/types'
import {getSingleBuildArg} from '../../../../../rest/builds'
import {getBuildLocator} from '../../../../../rest/locators'
import {loadEndpoint} from '../../../../../routes/loadEndpoint'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'

export const preloadAgentSummary =
  (buildId: BuildId | null | undefined): AppThunk<LoadedEndpoints> =>
  dispatch =>
    buildId != null
      ? [
          dispatch(
            loadEndpoint(
              restApi.endpoints.getBuildNormalized,
              getSingleBuildArg(getBuildLocator(buildId)),
            ),
          ),
        ]
      : []
